import _defineProperty from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";
import "core-js/modules/es6.function.name";

var _types$UPDATE_VIP_PAR;

import * as types from "@/store/constants/types";
export default (_types$UPDATE_VIP_PAR = {}, _defineProperty(_types$UPDATE_VIP_PAR, types.UPDATE_VIP_PARAMS, function (state, payLoad) {
  var func = payLoad.func,
      name = payLoad.name,
      count = payLoad.count;
  console.log(func, name);
  state[func][name] = count;
}), _defineProperty(_types$UPDATE_VIP_PAR, types.UPDATE_VIP_ROUTER_DATA, function (state, payLoad) {
  state.vipRouterData = payLoad;
}), _defineProperty(_types$UPDATE_VIP_PAR, types.UPDATE_CARD_CLICK_TIMES, function (state, payLoad) {
  state.cardClickTimes++;
}), _types$UPDATE_VIP_PAR);